import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs";
import { AppConfig } from "../../app-config";
import { tap } from "rxjs/operators";
import { TokenStorageService } from "../auth/token-storage.service";
import { FuseNavigationService } from "@fuse/components/navigation/navigation.service";

const httpOptions = {
    headers: new HttpHeaders({ "Content-Type": "application/json" }),
    observe: "response" as "body",
};

@Injectable({
    providedIn: "root",
})
export class UsersService {
    constructor(
        private http: HttpClient,
        private tokenStorage: TokenStorageService,
        private _fuseNavigationService: FuseNavigationService,
        private appConfig: AppConfig
    ) {
        this.API_URL = appConfig.api_url;
    }
    API_URL = "";

    /*
    '2','Admin'
    '3','Analista'
    '1','Auditor'
    '4','Dueño'
    '5','Especialista en Riesgos'
    '7','Evaluador'
    '6','Oficial de Cumplimiento'
  */

    findByCorreoElectronico(correoElectronico): Observable<any> {
        return this.http.post(
            this.API_URL + "usuarios/username", {"correoElectronico": correoElectronico},
            httpOptions
        );
    }

    get(usuarioId): Observable<any> {
        return this.http.get(
            this.API_URL + "usuarios/" + usuarioId,
            httpOptions
        );
    }

    getAll(page, pageSize): Observable<any> {
        return this.http
            .get(
                this.API_URL +
                    "usuarios/all?pagina=" +
                    page +
                    "&cantidad=" +
                    pageSize,
                httpOptions
            )
            .pipe(
                tap((users) => {
                    return users;
                })
            );
    }

    count(): Observable<any> {
        return this.http.get(this.API_URL + "usuarios/count", httpOptions);
    }

    register(user): Observable<any> {
        return this.http.post(this.API_URL + "usuarios/add", user, httpOptions);
    }

    ///{id}/add/estructura
    addNodo(id, nodo): Observable<any> {
        return this.http.post(
            this.API_URL + `usuarios/${id}/add/estructura`,
            nodo,
            httpOptions
        );
    }

    removeNodo(id, nodo): Observable<any> {
        return this.http.post(
            this.API_URL + `usuarios/${id}/remove/estructura`,
            nodo,
            httpOptions
        );
    }

    delete(id): Observable<any> {
        return this.http.delete(this.API_URL + "usuarios/" + id, httpOptions);
    }

    edit(id, user): Observable<any> {
        return this.http.put(
            this.API_URL + "usuarios/" + id,
            user,
            httpOptions
        );
    }

    reset(id): Observable<any> {
        return this.http.get(
            this.API_URL + `usuarios/${id}/reset_password`,
            httpOptions
        );
    }

    // Chanchullo, se necesita sustituir por guardar la empresa en el jwt
    setPassword(usuario): Observable<any> {
        var httpOptionsLocal = {
            headers: new HttpHeaders({
                "Content-Type": "application/x-www-form-urlencoded",
            }),
            //observe: 'response' as 'body'
        };

        return this.http.post(
            this.API_URL + "usuarios/change_password",
            {},
            {
                ...httpOptionsLocal,
                params: {
                    psw_anterior: usuario.pswAnterior,
                    psw_nuevo: usuario.pswNuevo,
                },
            }
        );
    }

    enroll(): Observable<any> {
        return this.http.get(
            this.API_URL + "usuarios/enroll_token",
            httpOptions
        );
    }

    generateMenu(role) {
        this._fuseNavigationService.updateNavigationItem("configuracion", {
            hidden: true,
        });

        this._fuseNavigationService.updateNavigationItem(
            "todasLasEvaluaciones",
            {
                hidden: true,
            }
        );

        this._fuseNavigationService.updateNavigationItem("misEvaluaciones", {
            hidden: true,
        });

        this._fuseNavigationService.updateNavigationItem("analisisDeBrechas", {
            hidden: true,
        });

        this._fuseNavigationService.updateNavigationItem("tiposDeEvaluacion", {
            hidden: true,
        });

        this._fuseNavigationService.updateNavigationItem("dimensiones", {
            hidden: true,
        });

        this._fuseNavigationService.updateNavigationItem(
            "estructurasJerarquicas",
            {
                hidden: true,
            }
        );

        this._fuseNavigationService.updateNavigationItem(
            "factoresDePonderacion",
            {
                hidden: true,
            }
        );

        this._fuseNavigationService.updateNavigationItem("reglasBase", {
            hidden: true,
        });

        this._fuseNavigationService.updateNavigationItem("riesgos", {
            hidden: true,
        });

        this._fuseNavigationService.updateNavigationItem("controles", {
            hidden: true,
        });

        this._fuseNavigationService.updateNavigationItem("objetivos", {
            hidden: true,
        });

        this._fuseNavigationService.updateNavigationItem("escenario", {
            hidden: true,
        });

        this._fuseNavigationService.updateNavigationItem("usuarios", {
            hidden: true,
        });

        this._fuseNavigationService.updateNavigationItem("evaluaciones", {
            hidden: true,
        });

        this._fuseNavigationService.updateNavigationItem("consolidacion", {
            hidden: true,
        });

        this._fuseNavigationService.updateNavigationItem("consolidar", {
            hidden: true,
        });

        this._fuseNavigationService.updateNavigationItem(
            "misEvaluacionesConsolidadas",
            {
                hidden: true,
            }
        );

        this._fuseNavigationService.updateNavigationItem("listados", {
            hidden: true,
        });

        this._fuseNavigationService.updateNavigationItem("dashboard", {
            hidden: true,
        });
        this._fuseNavigationService.updateNavigationItem(
            "preiniciarEvaluacion",
            {
                hidden: true,
            }
        );
        this._fuseNavigationService.updateNavigationItem("seguimientoKri", {
            hidden: true,
        });
        this._fuseNavigationService.updateNavigationItem("misKri", {
            hidden: true,
        });

        this._fuseNavigationService.updateNavigationItem(
            "listadoDetalladoDeLaEvaluacion",
            {
                hidden: true,
            }
        );
        this._fuseNavigationService.updateNavigationItem(
            "listadoDeControlesSugeridos",
            {
                hidden: true,
            }
        );
        this._fuseNavigationService.updateNavigationItem(
            "listadoDeMedidasDeContingencia",
            {
                hidden: true,
            }
        );
        this._fuseNavigationService.updateNavigationItem("listadoDeKri", {
            hidden: true,
        });
        this._fuseNavigationService.updateNavigationItem(
            "listadoDeControlesCriticos",
            {
                hidden: true,
            }
        );
        this._fuseNavigationService.updateNavigationItem(
            "listadoDeCumplimiento",
            {
                hidden: true,
            }
        );
        this._fuseNavigationService.updateNavigationItem(
            "verPistasDeAuditoria",
            {
                hidden: true,
            }
        );

        this._fuseNavigationService.updateNavigationItem("marcoDeReferencia", {
            hidden: true,
        });

        this._fuseNavigationService.updateNavigationItem("tablaDeEvaluacion", {
            hidden: true,
        });

        this._fuseNavigationService.updateNavigationItem("seguimientoMisKri", {
            hidden: true,
        });

        this._fuseNavigationService.updateNavigationItem("debidaDiligencia", {
            hidden: true,
        });

        this._fuseNavigationService.updateNavigationItem("verManual", {
            hidden: true,
        });

        if (role != null)
            for (var i = 0; i < role.length; i++) {
                this._fuseNavigationService.updateNavigationItem("verManual", {
                    hidden: false,
                });

                switch (role[i]) {
                    case 2: {
                        //Admin

                        this._fuseNavigationService.updateNavigationItem(
                            "seguimientoMisKri",
                            {
                                hidden: false,
                            }
                        );

                        this._fuseNavigationService.updateNavigationItem(
                            "configuracion",
                            {
                                hidden: false,
                            }
                        );

                        this._fuseNavigationService.updateNavigationItem(
                            "analisisDeBrechas",
                            {
                                hidden: false,
                            }
                        );

                        this._fuseNavigationService.updateNavigationItem(
                            "misEvaluaciones",
                            {
                                hidden: false,
                            }
                        );

                        this._fuseNavigationService.updateNavigationItem(
                            "todasLasEvaluaciones",
                            {
                                hidden: false,
                            }
                        );

                        this._fuseNavigationService.updateNavigationItem(
                            "tiposDeEvaluacion",
                            {
                                hidden: false,
                            }
                        );

                        this._fuseNavigationService.updateNavigationItem(
                            "dimensiones",
                            {
                                hidden: false,
                            }
                        );

                        this._fuseNavigationService.updateNavigationItem(
                            "estructurasJerarquicas",
                            {
                                hidden: false,
                            }
                        );

                        this._fuseNavigationService.updateNavigationItem(
                            "factoresDePonderacion",
                            {
                                hidden: false,
                            }
                        );

                        this._fuseNavigationService.updateNavigationItem(
                            "reglasBase",
                            {
                                hidden: false,
                            }
                        );

                        this._fuseNavigationService.updateNavigationItem(
                            "riesgos",
                            {
                                hidden: false,
                            }
                        );

                        this._fuseNavigationService.updateNavigationItem(
                            "controles",
                            {
                                hidden: false,
                            }
                        );

                        this._fuseNavigationService.updateNavigationItem(
                            "objetivos",
                            {
                                hidden: false,
                            }
                        );

                        this._fuseNavigationService.updateNavigationItem(
                            "escenario",
                            {
                                hidden: false,
                            }
                        );

                        this._fuseNavigationService.updateNavigationItem(
                            "usuarios",
                            {
                                hidden: false,
                            }
                        );

                        this._fuseNavigationService.updateNavigationItem(
                            "evaluaciones",
                            {
                                hidden: false,
                            }
                        );

                        this._fuseNavigationService.updateNavigationItem(
                            "consolidacion",
                            {
                                hidden: false,
                            }
                        );

                        this._fuseNavigationService.updateNavigationItem(
                            "consolidar",
                            {
                                hidden: false,
                            }
                        );

                        this._fuseNavigationService.updateNavigationItem(
                            "misEvaluacionesConsolidadas",
                            {
                                hidden: false,
                            }
                        );

                        this._fuseNavigationService.updateNavigationItem(
                            "listados",
                            {
                                hidden: false,
                            }
                        );

                        this._fuseNavigationService.updateNavigationItem(
                            "dashboard",
                            {
                                hidden: false,
                            }
                        );
                        this._fuseNavigationService.updateNavigationItem(
                            "seguimientoKri",
                            {
                                hidden: false,
                            }
                        );
                        this._fuseNavigationService.updateNavigationItem(
                            "misKri",
                            {
                                hidden: false,
                            }
                        );
                        this._fuseNavigationService.updateNavigationItem(
                            "preiniciarEvaluacion",
                            {
                                hidden: false,
                            }
                        );

                        this._fuseNavigationService.updateNavigationItem(
                            "listadoDetalladoDeLaEvaluacion",
                            {
                                hidden: false,
                            }
                        );
                        this._fuseNavigationService.updateNavigationItem(
                            "listadoDeControlesSugeridos",
                            {
                                hidden: false,
                            }
                        );
                        this._fuseNavigationService.updateNavigationItem(
                            "listadoDeMedidasDeContingencia",
                            {
                                hidden: false,
                            }
                        );
                        this._fuseNavigationService.updateNavigationItem(
                            "listadoDeKri",
                            {
                                hidden: false,
                            }
                        );
                        this._fuseNavigationService.updateNavigationItem(
                            "listadoDeControlesCriticos",
                            {
                                hidden: false,
                            }
                        );
                        this._fuseNavigationService.updateNavigationItem(
                            "listadoDeCumplimiento",
                            {
                                hidden: false,
                            }
                        );
                        this._fuseNavigationService.updateNavigationItem(
                            "verPistasDeAuditoria",
                            {
                                hidden: false,
                            }
                        );

                        this._fuseNavigationService.updateNavigationItem(
                            "marcoDeReferencia",
                            {
                                hidden: false,
                            }
                        );

                        this._fuseNavigationService.updateNavigationItem(
                            "tablaDeEvaluacion",
                            {
                                hidden: false,
                            }
                        );

                        this._fuseNavigationService.updateNavigationItem(
                            "debidaDiligencia",
                            {
                                hidden: false,
                            }
                        );

                        break;
                    }
                    case 5: {
                        //Especialista en Riesgos

                        this._fuseNavigationService.updateNavigationItem(
                            "configuracion",
                            {
                                hidden: false,
                            }
                        );

                        this._fuseNavigationService.updateNavigationItem(
                            "todasLasEvaluaciones",
                            {
                                hidden: false,
                            }
                        );

                        this._fuseNavigationService.updateNavigationItem(
                            "analisisDeBrechas",
                            {
                                hidden: false,
                            }
                        );

                        this._fuseNavigationService.updateNavigationItem(
                            "tiposDeEvaluacion",
                            {
                                hidden: false,
                            }
                        );

                        this._fuseNavigationService.updateNavigationItem(
                            "dimensiones",
                            {
                                hidden: false,
                            }
                        );

                        this._fuseNavigationService.updateNavigationItem(
                            "estructurasJerarquicas",
                            {
                                hidden: false,
                            }
                        );

                        this._fuseNavigationService.updateNavigationItem(
                            "factoresDePonderacion",
                            {
                                hidden: false,
                            }
                        );

                        this._fuseNavigationService.updateNavigationItem(
                            "reglasBase",
                            {
                                hidden: false,
                            }
                        );

                        this._fuseNavigationService.updateNavigationItem(
                            "riesgos",
                            {
                                hidden: false,
                            }
                        );

                        this._fuseNavigationService.updateNavigationItem(
                            "controles",
                            {
                                hidden: false,
                            }
                        );

                        this._fuseNavigationService.updateNavigationItem(
                            "objetivos",
                            {
                                hidden: false,
                            }
                        );

                        this._fuseNavigationService.updateNavigationItem(
                            "escenario",
                            {
                                hidden: false,
                            }
                        );

                        this._fuseNavigationService.updateNavigationItem(
                            "evaluaciones",
                            {
                                hidden: false,
                            }
                        );

                        this._fuseNavigationService.updateNavigationItem(
                            "preiniciarEvaluacion",
                            {
                                hidden: false,
                            }
                        );

                        this._fuseNavigationService.updateNavigationItem(
                            "consolidacion",
                            {
                                hidden: false,
                            }
                        );

                        this._fuseNavigationService.updateNavigationItem(
                            "consolidar",
                            {
                                hidden: false,
                            }
                        );

                        this._fuseNavigationService.updateNavigationItem(
                            "misEvaluacionesConsolidadas",
                            {
                                hidden: false,
                            }
                        );

                        this._fuseNavigationService.updateNavigationItem(
                            "listados",
                            {
                                hidden: false,
                            }
                        );

                        this._fuseNavigationService.updateNavigationItem(
                            "dashboard",
                            {
                                hidden: false,
                            }
                        );

                        this._fuseNavigationService.updateNavigationItem(
                            "seguimientoKri",
                            {
                                hidden: false,
                            }
                        );
                        this._fuseNavigationService.updateNavigationItem(
                            "misKri",
                            {
                                hidden: false,
                            }
                        );

                        this._fuseNavigationService.updateNavigationItem(
                            "listadoDetalladoDeLaEvaluacion",
                            {
                                hidden: false,
                            }
                        );
                        this._fuseNavigationService.updateNavigationItem(
                            "listadoDeControlesSugeridos",
                            {
                                hidden: false,
                            }
                        );
                        this._fuseNavigationService.updateNavigationItem(
                            "listadoDeMedidasDeContingencia",
                            {
                                hidden: false,
                            }
                        );
                        this._fuseNavigationService.updateNavigationItem(
                            "listadoDeKri",
                            {
                                hidden: false,
                            }
                        );
                        this._fuseNavigationService.updateNavigationItem(
                            "listadoDeControlesCriticos",
                            {
                                hidden: false,
                            }
                        );
                        this._fuseNavigationService.updateNavigationItem(
                            "listadoDeCumplimiento",
                            {
                                hidden: false,
                            }
                        );
                        this._fuseNavigationService.updateNavigationItem(
                            "verPistasDeAuditoria",
                            {
                                hidden: false,
                            }
                        );

                        this._fuseNavigationService.updateNavigationItem(
                            "marcoDeReferencia",
                            {
                                hidden: false,
                            }
                        );

                        this._fuseNavigationService.updateNavigationItem(
                            "tablaDeEvaluacion",
                            {
                                hidden: false,
                            }
                        );
                        break;
                    }
                    case 4: {
                        //Dueño

                        this._fuseNavigationService.updateNavigationItem(
                            "seguimientoMisKri",
                            {
                                hidden: false,
                            }
                        );

                        this._fuseNavigationService.updateNavigationItem(
                            "misEvaluaciones",
                            {
                                hidden: false,
                            }
                        );

                        this._fuseNavigationService.updateNavigationItem(
                            "configuracion",
                            {
                                hidden: false,
                            }
                        );

                        this._fuseNavigationService.updateNavigationItem(
                            "tiposDeEvaluacion",
                            {
                                hidden: false,
                            }
                        );

                        this._fuseNavigationService.updateNavigationItem(
                            "dimensiones",
                            {
                                hidden: false,
                            }
                        );

                        this._fuseNavigationService.updateNavigationItem(
                            "estructurasJerarquicas",
                            {
                                hidden: false,
                            }
                        );

                        this._fuseNavigationService.updateNavigationItem(
                            "factoresDePonderacion",
                            {
                                hidden: false,
                            }
                        );

                        this._fuseNavigationService.updateNavigationItem(
                            "riesgos",
                            {
                                hidden: false,
                            }
                        );

                        this._fuseNavigationService.updateNavigationItem(
                            "controles",
                            {
                                hidden: false,
                            }
                        );

                        this._fuseNavigationService.updateNavigationItem(
                            "objetivos",
                            {
                                hidden: false,
                            }
                        );

                        this._fuseNavigationService.updateNavigationItem(
                            "escenario",
                            {
                                hidden: false,
                            }
                        );

                        this._fuseNavigationService.updateNavigationItem(
                            "reglasBase",
                            {
                                hidden: false,
                            }
                        );

                        /*
              this._fuseNavigationService.updateNavigationItem('usuarios', {
                  hidden: false
              });*/

                        this._fuseNavigationService.updateNavigationItem(
                            "evaluaciones",
                            {
                                hidden: false,
                            }
                        );

                        this._fuseNavigationService.updateNavigationItem(
                            "consolidacion",
                            {
                                hidden: false,
                            }
                        );

                        this._fuseNavigationService.updateNavigationItem(
                            "consolidar",
                            {
                                hidden: false,
                            }
                        );

                        this._fuseNavigationService.updateNavigationItem(
                            "misEvaluacionesConsolidadas",
                            {
                                hidden: false,
                            }
                        );

                        this._fuseNavigationService.updateNavigationItem(
                            "listados",
                            {
                                hidden: false,
                            }
                        );

                        this._fuseNavigationService.updateNavigationItem(
                            "dashboard",
                            {
                                hidden: false,
                            }
                        );

                        this._fuseNavigationService.updateNavigationItem(
                            "seguimientoKri",
                            {
                                hidden: false,
                            }
                        );
                        this._fuseNavigationService.updateNavigationItem(
                            "misKri",
                            {
                                hidden: false,
                            }
                        );
                        this._fuseNavigationService.updateNavigationItem(
                            "preiniciarEvaluacion",
                            {
                                hidden: false,
                            }
                        );

                        this._fuseNavigationService.updateNavigationItem(
                            "listadoDetalladoDeLaEvaluacion",
                            {
                                hidden: false,
                            }
                        );
                        this._fuseNavigationService.updateNavigationItem(
                            "listadoDeControlesSugeridos",
                            {
                                hidden: false,
                            }
                        );
                        this._fuseNavigationService.updateNavigationItem(
                            "listadoDeMedidasDeContingencia",
                            {
                                hidden: false,
                            }
                        );
                        this._fuseNavigationService.updateNavigationItem(
                            "listadoDeKri",
                            {
                                hidden: false,
                            }
                        );
                        this._fuseNavigationService.updateNavigationItem(
                            "listadoDeControlesCriticos",
                            {
                                hidden: false,
                            }
                        );
                        this._fuseNavigationService.updateNavigationItem(
                            "listadoDeCumplimiento",
                            {
                                hidden: false,
                            }
                        );
                        this._fuseNavigationService.updateNavigationItem(
                            "verPistasDeAuditoria",
                            {
                                hidden: false,
                            }
                        );
                        break;
                    }

                    case 3: {
                        //Analista

                        this._fuseNavigationService.updateNavigationItem(
                            "seguimientoMisKri",
                            {
                                hidden: false,
                            }
                        );

                        this._fuseNavigationService.updateNavigationItem(
                            "misEvaluaciones",
                            {
                                hidden: false,
                            }
                        );

                        this._fuseNavigationService.updateNavigationItem(
                            "configuracion",
                            {
                                hidden: false,
                            }
                        );

                        this._fuseNavigationService.updateNavigationItem(
                            "evaluaciones",
                            {
                                hidden: false,
                            }
                        );

                        this._fuseNavigationService.updateNavigationItem(
                            "estructurasJerarquicas",
                            {
                                hidden: false,
                            }
                        );

                        break;
                    }

                    case 6: {
                        //Oficial de cumplimiento
                        this._fuseNavigationService.updateNavigationItem(
                            "configuracion",
                            {
                                hidden: false,
                            }
                        );

                        this._fuseNavigationService.updateNavigationItem(
                            "todasLasEvaluaciones",
                            {
                                hidden: false,
                            }
                        );

                        this._fuseNavigationService.updateNavigationItem(
                            "analisisDeBrechas",
                            {
                                hidden: false,
                            }
                        );

                        this._fuseNavigationService.updateNavigationItem(
                            "reglasBase",
                            {
                                hidden: false,
                            }
                        );

                        this._fuseNavigationService.updateNavigationItem(
                            "listados",
                            {
                                hidden: false,
                            }
                        );

                        this._fuseNavigationService.updateNavigationItem(
                            "listadoDeCumplimiento",
                            {
                                hidden: false,
                            }
                        );

                        this._fuseNavigationService.updateNavigationItem(
                            "marcoDeReferencia",
                            {
                                hidden: false,
                            }
                        );

                        this._fuseNavigationService.updateNavigationItem(
                            "tablaDeEvaluacion",
                            {
                                hidden: false,
                            }
                        );
                        break;
                    }

                    case 7: {
                        this._fuseNavigationService.updateNavigationItem(
                            "analisisDeBrechas",
                            {
                                hidden: false,
                            }
                        );
                        break;
                    }
                    case 1: {
                        //Auditor
                        this._fuseNavigationService.updateNavigationItem(
                            "controles",
                            {
                                hidden: false,
                            }
                        );

                        this._fuseNavigationService.updateNavigationItem(
                            "reglasBase",
                            {
                                hidden: false,
                            }
                        );

                        this._fuseNavigationService.updateNavigationItem(
                            "marcoDeReferencia",
                            {
                                hidden: false,
                            }
                        );

                        this._fuseNavigationService.updateNavigationItem(
                            "evaluaciones",
                            {
                                hidden: false,
                            }
                        );

                        this._fuseNavigationService.updateNavigationItem(
                            "configuracion",
                            {
                                hidden: false,
                            }
                        );

                        this._fuseNavigationService.updateNavigationItem(
                            "controles",
                            {
                                hidden: false,
                            }
                        );

                        this._fuseNavigationService.updateNavigationItem(
                            "todasLasEvaluaciones",
                            {
                                hidden: false,
                            }
                        );

                        this._fuseNavigationService.updateNavigationItem(
                            "estructurasJerarquicas",
                            {
                                hidden: false,
                            }
                        );

                        this._fuseNavigationService.updateNavigationItem(
                            "consolidacion",
                            {
                                hidden: false,
                            }
                        );

                        this._fuseNavigationService.updateNavigationItem(
                            "escenario",
                            {
                                hidden: false,
                            }
                        );

                        this._fuseNavigationService.updateNavigationItem(
                            "seguimientoKri",
                            {
                                hidden: false,
                            }
                        );
                        this._fuseNavigationService.updateNavigationItem(
                            "misKri",
                            {
                                hidden: false,
                            }
                        );

                        this._fuseNavigationService.updateNavigationItem(
                            "listados",
                            {
                                hidden: false,
                            }
                        );
                        this._fuseNavigationService.updateNavigationItem(
                            "verPistasDeAuditoria",
                            {
                                hidden: false,
                            }
                        );
                        break;
                    }
                    case 8: {
                        //Representante Legal

                        this._fuseNavigationService.updateNavigationItem(
                            "debidaDiligencia",
                            {
                                hidden: false,
                            }
                        );

                        //HIDE: configuracionDiligencia
                        //sujetoObligadoDiligencia
                        //formularioDeReferenciaDebidaDiligencia

                        this._fuseNavigationService.updateNavigationItem(
                            "configuracionDiligencia",
                            {
                                hidden: true,
                            }
                        );

                        this._fuseNavigationService.updateNavigationItem(
                            "sujetoObligadoDiligencia",
                            {
                                hidden: true,
                            }
                        );

                        this._fuseNavigationService.updateNavigationItem(
                            "formularioDeReferenciaDebidaDiligencia",
                            {
                                hidden: true,
                            }
                        );

                        break;
                    }
                    default: {
                        break;
                    }
                }
            }
    }
}
